import { LocalDate } from '@spa-frontend/date-lib';

export function getAge(birthDate: LocalDate, timezone: string): number {
    return LocalDate.now(timezone).diff(birthDate, 'year', true);
}
